import MyOfferings from "./YogaOfferings";
import YogaNavBar from "./YogaNavBar";
import EventbriteModal from "./eventbriteModal";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function Services() {
    const [natureFlowIsOpen, setNatureFlowIsOpen ] = useState(false);
    const [privateIsOpen, setPrivateIsOpen ] = useState(false);
    const [corporateIsOpen, setCorporateIsOpen ] = useState(false);
    const [eventIsOpen, setEventIsOpen ] = useState(false)




    return(
        <>

        <YogaNavBar />
        <div className="md:flex bg-neutral-50 py-10">
        <div className="md:w-1/2 m-5">
        <h className="md:text-center md:mx-10 text-4xl ">Work with me</h>
        <p className="md:mx-10 my-5 md:text-xl text-lg ">I offer grounding, nature-inspired yoga to support well-being, clarity, and connection—both individually and in community. Whether you're seeking a personalized practice, mindful movement at work, or an outdoor class in San Diego, my offerings are designed to meet you where you are.</p>
        </div>
        <div className="md:w-1/2 m-5 mt-10">
        <ul className="text-lg my-5">
        <li>
            <div className="flex justify-between items-center"
            onClick={() => setNatureFlowIsOpen(!natureFlowIsOpen)}>
                <h2>Nature Flow – Balboa Park</h2>
                <button className="text-4xl md:mr-10">{natureFlowIsOpen ? "–" : "+"}</button>
            </div>
            {natureFlowIsOpen && (
        <div className="mt-2 text-gray-700 text-sm ">
          <p className="mb-5">
          Unroll your mat and connect with the earth. Every Sunday at 10 AM we come together to move and breathe, finding harmony with our natural surroundings. All experience levels are welcome.
          </p>
          <button
        className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
      >
        <Link to="https://sinainfluxyoga.setmore.com/classes/ea9e0268-6e6c-402a-93b4-964b6324c365">Sign Up Here</Link>

      </button>
        </div>
      )}
        </li>
            <li>
            <hr class="h-px my-5 md:mr-10 border-0 dark:bg-gray-700"/>
            <div className="flex justify-between items-center"
            onClick={() => setPrivateIsOpen(!privateIsOpen)}>
                <h2>Private Sessions</h2>
                <span className="text-4xl md:mr-10">{privateIsOpen ? "–" : "+"}</span>
            </div>
            {privateIsOpen && (
        <div className="mt-2 text-gray-700 text-sm mb-10">
          <p className="mb-5">
          Whether you're just beginning your yoga journey or looking to deepen your practice, private 1:1 sessions offer personalized guidance tailored to your needs and goals. These sessions allow for focused attention, alignment support, and a pace that works just for you—available in person (at home, outdoors, or in studio) or online to meet you wherever you are.
          </p>
          <Link
          to="/yoga/contact"
        className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
      >
            Contact Me
      </Link>
        </div>
      )}

            </li>
            <li>
            <hr class="h-px my-5 md:mr-10 border-0 dark:bg-gray-700"/>
            <div className="flex justify-between items-center"
            onClick={() => setCorporateIsOpen(!corporateIsOpen)}>
                <h2>Corporate Yoga</h2>
                <span className="text-4xl md:mr-10">{corporateIsOpen ? "–" : "+"}</span>
            </div>
            {corporateIsOpen && (
        <div className="mt-2 text-gray-700 text-sm mb-10">
          <p className="mb-5">
          Support your team's well-being with on-site or virtual yoga classes designed to reduce stress, improve focus, and promote a healthier workplace culture. Whether it's a midday reset, a morning energy boost, or part of a wellness initiative, corporate yoga helps teams reconnect, recharge, and show up with more clarity and calm.
          </p>
          <Link
          to="/yoga/contact"
        className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded "
      >
            Contact Me
      </Link>
        </div>
      )}
            </li>
            <li>
            <hr class="h-px my-5 md:mr-10 border-0 dark:bg-gray-700"/>
            <div className="flex justify-between items-center"
            onClick={() => setEventIsOpen(!eventIsOpen)}>
                <h2>Events</h2>
                <span className="text-4xl md:mr-10">{eventIsOpen ? "–" : "+"}</span>
            </div>
            {eventIsOpen && (
        <div className="mt-2 text-gray-700 text-sm ">
          <p className="mb-5">
          Whether it’s a community gathering, wellness pop-up, or a sober social event, I offer yoga sessions that create space for connection, grounding, and joy. These event-based classes are designed to meet the moment—inviting people to move, breathe, and feel present together in beautiful, welcoming settings.
          </p>
          <Link
          to="/yoga/contact"
        className="text-white bg-purple-500 hover:bg-purple-700 px-4 py-2 rounded"
      >
            Let's collaborate
      </Link>
        </div>
      )}

            </li>
        </ul>
        </div>
</div>

        {/* <img
                src={require("./images/park_yoga.jpeg")}
                alt="Yoga in Arizona"
                className="w-full h-[200px] md:h-[300px] object-cover"
            /> */}
        <MyOfferings />
        </>
    )
}
